import { defineBlock, smartProps, ChildrenBlock } from '@smartfire/js-block-engine';
import EditableHeading from '@smartfire/components/editable-heading';
import style from './block.module.scss';

function Logos() {
    return (
        <div className={style.blockLogos}>
            <EditableHeading smartProp="title" placeholder="Titre" className={style.title} />
            <ChildrenBlock
                gutenbergEditorConfig={{
                    orientation: 'horizontal',
                    allowedBlocks: ['smartfire/logos---logo'],
                    template: [
                        ['smartfire/logos---logo', {}],
                        ['smartfire/logos---logo', {}],
                        ['smartfire/logos---logo', {}],
                        ['smartfire/logos---logo', {}],
                        ['smartfire/logos---logo', {}],
                        ['smartfire/logos---logo', {}],
                    ],
                }}
                className={style.contentLogos}
            />
        </div>
    );
}

export default defineBlock({
    Block: Logos,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 2,
            content: '',
        }),
    },
    setup: {
        title: 'Logos',
    },
});
